export const BASE_PATH = 'https://kinopoiskapiunofficial.tech/api/v2.2/films';
export const API_KEY = 'b45515aa-44d2-48db-86f0-1f2056a5e4d1';
